export const ON_SEARCH_CHANGE = 'ON_SEARCH_CHANGE';

export const REQUEST_BOOK_PENDING = 'REQUEST_BOOK_PENDING'
export const REQUEST_BOOK_SUCCESS = 'REQUEST_BOOK_SUCCESS'
export const REQUEST_BOOK_FAILED = 'REQUEST_BOOK_FAILED'

export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';